import * as actionTypes from './actionTypes';

export const fetchDeletedDocuments = (spaceId) => ({
  type: actionTypes.FETCH_DOCUMENTS,
  spaceId,
});
export const fetchDeletedDocumentsSuccess = (ids) => ({
  type: actionTypes.FETCH_DOCUMENTS_SUCCESS,
  ids,
});


export const fetchDeletedFolders = (spaceId) => ({
  type: actionTypes.FETCH_FOLDERS,
  spaceId,
});
export const fetchDeletedFoldersSuccess = (ids) => ({
  type: actionTypes.FETCH_FOLDERS_SUCCESS,
  ids,
});


export const restoreDocuments = (documents) => ({
  type: actionTypes.RESTORE_DOCUMENTS,
  documents,
});
export const restoreDocumentsSuccess = (ids) => ({
  type: actionTypes.RESTORE_DOCUMENTS_SUCCESS,
  ids,
});
